import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMaximize = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMaximize.dimensions.width} ${IconMaximize.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="m23.479 16.402-1.073.003.019 6.912-6.624.02.003 1.118 7.696-.019-.021-8.034ZM8.196.545.5.564l.021 8.034 1.073-.003-.019-6.912 6.624-.02L8.196.546V.545ZM1.633 23.378l-.018-6.912-1.072.003L.56 24.5l7.7-.022-.004-1.12-6.624.02h.001ZM15.74.522l.003 1.12 6.623-.02.019 6.912 1.072-.003L23.44.5l-7.7.022Z"
        fill={color || Color.premiumBlack}
        fillRule="nonzero"
      />
    </Svg>
  )
}

IconMaximize.dimensions = {
  width: 24,
  height: 25,
}

export default IconMaximize
